/** Detección de plataforma para el flujo de instalación de la PWA. */

import { esNativo } from "./nativo";

export function isIos(): boolean {
  // iPadOS 13+ se reporta como Mac; el touch lo delata.
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/.test(ua) || (ua.includes("Mac") && navigator.maxTouchPoints > 1);
}

export function isAndroid(): boolean {
  return /Android/i.test(navigator.userAgent);
}

/** Celular (iOS o Android): donde tiene sentido ofrecer "agregar a inicio". */
export function isMobile(): boolean {
  return isIos() || isAndroid();
}

/**
 * "Corre como app instalada y no como pestaña." Lo preguntan 19 archivos para
 * decidir si ofrecer "agregá a inicio", si hay menú de compartir, si el candado
 * biométrico tiene sentido.
 *
 * ADENTRO DE LA APP NATIVA ES TRUE SIEMPRE, y acá está la única línea que hace
 * falta para eso: en el WebView de una app el `display-mode` es `browser` y
 * `navigator.standalone` no existe, así que sin esto la app de iPhone se
 * pasaría la vida pidiéndole al usuario que la instale — estando instalada.
 * Arreglarlo en el origen arregla los 19 lugares de una vez, porque la
 * pregunta que todos hacen es exactamente ésta.
 */
export function isStandalone(): boolean {
  if (esNativo()) return true;
  // display-mode cubre Android/desktop; navigator.standalone es el legacy de iOS.
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (navigator as unknown as { standalone?: boolean }).standalone === true
  );
}

/**
 * Navegador interno de otra app (Instagram, Facebook, TikTok, LinkedIn, Line…).
 * Google bloquea el login en esos WebViews ("acceso bloqueado" /
 * disallowed_useragent). En iOS, WhatsApp abre los links en Safari View
 * Controller, que sí funciona, así que no se lista.
 */
export function isInAppBrowser(): boolean {
  return /FBAN|FBAV|FB_IAB|Instagram|TikTok|musical_ly|Line\/|LinkedInApp|Snapchat|Twitter|MicroMessenger/i.test(
    navigator.userAgent,
  );
}
